// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Menu = require("../../v5/common/Components/Menu.bs.js");
let IconV5 = require("../../v5/common/Components/IconV5.bs.js");
let ButtonsV5 = require("../../v5/common/Components/ButtonsV5.bs.js");
let View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function HeaderSearchDropdown(props) {
  return JsxRuntime.jsxs(Menu.Menu.make, {
    button: JsxRuntime.jsx(ButtonsV5.Button.make, {
      className: TailwindMerge.twMerge([
        "!border-none ml-1 mr-4 px-4 py-0 leading-normal bg-transparent block cursor-pointer relative h-full",
        "text-inherit font-inherit appearance-none"
      ]),
      children: JsxRuntime.jsx(View__Jsx3.make, {
        alignItems: "center",
        justifyContent: "flexStart",
        flexDirection: "row",
        children: JsxRuntime.jsx(IconV5.make, {
          icon: "search",
          size: 22,
          className: "text-zinc-500"
        })
      })
    }),
    children: [
      JsxRuntime.jsx(Menu.MenuItem.make, {
        href: "/properties?as_m=web&as_c=header_search_dropdown",
        children: "Search properties"
      }),
      JsxRuntime.jsx(Menu.MenuItem.make, {
        href: "/client_needs?as_m=web&as_c=header_search_dropdown",
        children: "Search buyer needs"
      }),
      JsxRuntime.jsx(Menu.MenuItem.make, {
        href: "/messages?as_m=web&as_c=header_search_dropdown",
        children: "Search broadcast messages"
      })
    ]
  });
}

let make = HeaderSearchDropdown;

exports.make = make;
/* Menu Not a pure module */
